import { Link } from 'react-router'
import image from './image.jpg'

export const SubscribeSection: React.FC = () => {
  return (
    <section className="px-5">
      <div className="-mx-5 relative overflow-hidden">
        <img src={image} alt="季節の枝ものを飾った部屋" className="w-full h-120 md:h-150 object-cover" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="bg-white/95 backdrop-blur-md rounded-3xl py-12 px-10 max-w-sm w-full">
            <h2 className="text-2xl md:text-3xl font-medium text-black leading-relaxed">
              まずは1ヶ月、
              <br />
              試してみてください
            </h2>
            <div className="mt-8 inline-flex flex-col items-center">
              <Link
                reloadDocument
                to="/subscription/branch/new"
                className="px-12 py-5 bg-accent text-white text-[14px] font-medium tracking-wide rounded-full hover:opacity-90 transition-opacity"
              >
                定期便を始める
              </Link>
              <p className="mt-3 text-[13px] text-main">違約金なし・いつでも解約OK</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
